import clsx from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './Estimate.module.css';
import Banner from '../Banner/Banner';
import Reciept from '../Reciept';
import {
  calcDesignEstimate,
  calcDevelopmentEstimate,
} from '../../functions/pricing/calcEstimate';
import FadeTransition, {
  FADE_DIRECTION,
} from '../common/FadeTransition/FadeTransition';
import ContactUs from '../contactUs';
import ModalNew from '../ModalNew';

const Estimate = ({ page }) => {
  const { answers } = useSelector((state) => state.Pricing);
  const [designEstimate] = useState(calcDesignEstimate(answers));
  const [developmentEstimate] = useState(calcDevelopmentEstimate(answers));
  const [showCallMe, setShowCallMe] = useState(false);
  const [showMaxReciept, setShowMaxReciept] = useState(false);
  const [amount] = useState({
    min: (designEstimate + developmentEstimate) * 0.5,
    max: designEstimate + developmentEstimate * 2,
  });
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return (
    <div className={clsx(styles.budgetBox, 'px-2')}>
      <div className={clsx('container', styles.estimateContainer)}>
        <div className={styles.headingHolder}>
          <strong className={clsx(styles.title, 'text-center py-2')}>
            App cost breakdown
          </strong>
        </div>
        <div className={clsx('row d-flex', styles.estimateRow)}>
          <div className="col col-12 ">
            <Banner heading="How this works." headingCenter addMargin={false}>
              <p>
                To help you attract top quality investors and partners quickly,
                this custom plan takes you all the way to publishing your app in <b>6 weeks</b>.
              </p>
              <p>
                This is a breakdown of time and cost to get a fully functional bug free public
                web or mobile app.
              </p>
              <p>
                You will see that the first step is
                {' '}
                <b>FREE !!</b>
              </p>
            </Banner>
          </div>

          <div className="col col-12 pb-2">
            <Banner
              heading="Phases in Detail"
              headingCenter
              secondary
              addMargin={false}
            >
              <h5>Development Plan</h5>
              <p>
                <b>
                  Get an idea of what we can do for you in 20
                  minutes!
                </b>
                <br />
                <p>
                  In this stage we create an inventory of screens you will need
                  built. We will consider your requirements and decide on the
                  infrastructure your app will need. All you need to do is
                  invest
                  {' '}
                  <b>20 minutes</b>
                  {' '}
                  of your time in an interview.
                </p>
                <p>
                  <b>What  is this good for?</b>
                  <br />
                  You will get an overview of the features that can be supported within your budget.
                </p>
                <p>To get a development plan click on the button below.</p>
              </p>
              <ul className={clsx(styles.cart_list)}>
                <li className={clsx(styles.cart_item, styles.hideMobile)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 1:
                    </span>
                    <span className={styles.week}>On Phone Call</span>
                  </div>
                  <div className="d-flex">
                    <span className={styles.name}>Written Plan</span>
                    <span className={styles.price}>FREE</span>
                  </div>
                </li>
                {/* for mobile */}
                <li className={clsx(styles.cart_item, styles.hideDesktop)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 1:
                    </span>
                    <span className={styles.name}>Written Plan</span>

                  </div>
                  <div className="d-flex">
                    <span className={styles.week}>On Phone Call</span>
                    <span className={styles.price}>FREE</span>
                  </div>
                </li>
              </ul>
              <div className={clsx(styles.btnHolder, styles.btnCenter)}>
                <button
                  className="btn-custom"
                  type="button"
                  onClick={() => setShowCallMe((prev) => !prev)}
                >
                  Get a Development Plan
                </button>
              </div>
              <hr className={styles.hr} />
              <h5>Outline Design</h5>
              <p>
                <b>
                  Have you wished you had a visual representation of how your
                  app works?
                </b>
                <br />
                The design outline provides this. The screens are drawn in black
                & white. Buttons and labels are placed to demonstrate
                functionality.
              </p>
              <p>
                <b>What  is this good for?</b>
                <br />
                It's a quick & dirty, low budget method of explaining your idea to investors,
                potential users and partners. It's far more effective than just words.
              </p>
              <ul className={styles.cart_list}>
                <li className={clsx(styles.cart_item, styles.hideMobile)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 2:
                    </span>
                    <span className={styles.week}>Starts:Week 1. Ends: Week 2</span>
                  </div>
                  <div className="d-flex">
                    <span className={styles.name}>Design Outline</span>
                    <span className={styles.price}>
                      {formatter.format(500)}
                    </span>
                  </div>
                </li>
                {/* for mobile */}
                <li className={clsx(styles.cart_item, styles.hideDesktop)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 2:
                    </span>
                    <span className={styles.name}>Design Outline</span>
                  </div>
                  <div className="d-flex">
                    <span className={styles.week}>Starts:Week 1. Ends: Week 2</span>
                    <span className={styles.price}>
                      {formatter.format(500)}
                    </span>
                  </div>
                </li>
              </ul>
              <hr className={styles.hr} />

              <h5>Detailed Design</h5>
              <p>
                <b>What will your app will look like when published?</b>
                <br />
                Have you seen listings for web/mobile apps? Many of the
                screenshots are images from the design stage. With a desgin,
                your app idea looks very real. In addition
                to the workflow you developed in the last stage, this will
                include your logo, brand colors, placeholder images and a lot of
                visual detail.
              </p>
              <p>
                <b>What this is good for?</b>
                <br />
                At this stage, you could (for example)
                raise funding through crowd funding on sites such as
                Kickstarter.com. When this is done you will be able to
                communicate to your investors, potential users and partners how
                your app will look when users download and use it.
              </p>

              <ul className={styles.cart_list}>
                <li className={clsx(styles.cart_item, styles.hideMobile)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 3:
                    </span>
                    <span className={styles.week}>Starts:Week 2. Ends: Week 3</span>
                  </div>
                  <div className="d-flex">
                    <span className={styles.name}>Detailed Design</span>
                    <span className={styles.price}>
                      {formatter.format(
                        designEstimate ? designEstimate - 500 : 0
                      )}
                    </span>
                  </div>
                </li>
                {/* for mobile */}
                <li className={clsx(styles.cart_item, styles.hideDesktop)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 3:
                    </span>
                    <span className={styles.name}>Detailed Design</span>

                  </div>
                  <div className="d-flex">
                    <span className={styles.week}>Starts:Week 2. Ends: Week 3</span>
                    <span className={styles.price}>
                      {formatter.format(
                        designEstimate ? designEstimate - 500 : 0
                      )}
                    </span>
                  </div>
                </li>
              </ul>
              <hr className={styles.hr} />

              <h5>Development and Testing</h5>
              <p>
                <b>Want to test out a private bug-free version of your app?</b>
                <br />
                Before releasing your app to the public, you will want to share
                the app with friends and partners to use and test a private
                bug-free version of your app to see how it will work for your
                users. To get this built we will code it. Then our quality
                testing team will test and flag bugs. The development team will
                fix the bugs. We repeat this loop as often as needed to make
                sure that all bugs are fixed. Once we are satisfied, we will
                send you links to your app to anyone you want while the app in
                private release mode. You will get weekly release updates from
                our team.
              </p>
              <p>
                <b>What is this good for?</b>
                <br />
                At the end of this stage you will have an app that you can test. You can share it with your partners
                and early users to get feedback.
              </p>

              <ul className={styles.cart_list}>
                <li className={clsx(styles.cart_item, styles.hideMobile)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 4:
                    </span>
                    <span className={styles.week}>Starts:Week 3. Ends: 7 week</span>
                  </div>
                  <div className="d-flex pr-1">
                    <span className={styles.name}>Development and Testing</span>
                    <span className={styles.price}>
                      {formatter.format(developmentEstimate / 2)}
                    </span>
                  </div>
                </li>
                {/* for mobile */}
                <li className={clsx(styles.cart_item, styles.hideDesktop)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 4:
                    </span>
                    <span className={styles.name}>Development and Testing</span>

                  </div>
                  <div className="d-flex pr-1">
                    <span className={styles.week}>Starts:Week 3. Ends: 7 week</span>
                    <span className={styles.price}>
                      {formatter.format(developmentEstimate / 2)}
                    </span>
                  </div>
                </li>
              </ul>
              <hr className={styles.hr} />

              <h5>Publish App</h5>
              <p>
                <b>Are you ready for your app to be publicly available?</b>
                <br />
                In this stage we publish to the web or the Google & Apple app stores. This includes
                applying for a public release. Apple and Google's approval for the app stores are beyond our control.
                Typically Google and Apple have policies that may require changes to your app's design.
              </p>
              <p>
                <b>What is this good for?</b>
                <br />
                Users outside of your team will be able to use your app at the end of this stage.
              </p>

              <ul className={styles.cart_list}>
                <li className={clsx(styles.cart_item, styles.hideMobile)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 5:
                    </span>
                    <span className={styles.week}>Starts:Week 5. Ends: 7 week</span>
                  </div>
                  <div className="d-flex pr-1">
                    <span className={styles.name}>Publish App</span>
                    <span className={styles.price}>
                      {formatter.format(developmentEstimate / 2)}
                    </span>
                  </div>
                </li>
                {/* for mobile */}
                <li className={clsx(styles.cart_item, styles.hideDesktop)}>
                  <div className="d-flex">
                    <span className={clsx(styles.index, 'd-block')}>
                      Phase 5:
                    </span>
                    <span className={styles.name}>Publish App</span>
                  </div>
                  <div className="d-flex pr-1">
                    <span className={styles.week}>Starts:Week 5. Ends: 7 week</span>

                    <span className={styles.price}>
                      {formatter.format(developmentEstimate / 2)}
                    </span>
                  </div>
                </li>
              </ul>
              <hr className={styles.hr} />
            </Banner>
          </div>
          <div className={clsx('d-flex flex-column py-4', styles.callbox)}>
            <div className={clsx(styles.btnWrap, 'py-4')}>
              <button
                type="button"
                className={clsx('btn-custom')}
                onClick={() => {
                  setShowMaxReciept(true);
                }}
              >
                Get Quote Summary
              </button>
              <h5>
                Total Cost:&nbsp;
                <strong>
                  {formatter.format(+designEstimate + developmentEstimate)}
                </strong>
              </h5>
            </div>
            <div className={clsx(styles.muchMore, styles.content)}>
              <div>
                <h5>
                  <br />
                  {' '}
                  Get the following:
                </h5>
                <ol>
                  <li>Get Screens Inventory & Custom Offer</li>
                  <li>Get the Strategy Secrets CheatSheet</li>
                  <li>
                    Ask about the
                    {' '}
                    <b>$500</b>
                    {' '}
                    StartApp Prize
                  </li>
                  <li>Estimate the value of your app.</li>
                </ol>

                <div className={clsx(styles.btnHolder, styles.btn_callme)}>
                  <button className="btn-custom" type="button" onClick={() => setShowCallMe((prev) => !prev)}>
                    Get a Call
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showMaxReciept && (
          <ModalNew isOpen={showMaxReciept} setIsOpen={setShowMaxReciept} title="Cost Estimate">

            <div className={clsx(styles.recieptHolder, 'mb-5')}>
              <Reciept
                design={designEstimate}
                development={developmentEstimate}
              />
            </div>
          </ModalNew>
          )}

          <div className="col col-12 pb-2">
            <Banner
              heading="Next Step"
              headingCenter
              secondary
              addMargin={false}
            >
              <p>
                <h3>Get a Plan</h3>
                <p>
                  You need a plan of action. You need something to help you
                  visualize what your app will look like. You need a real commitment to
                  deliver the app. You need a timeframe to publish your app so you can plan
                  other activities. You need to consider details that this calculator has not
                  covered.
                </p>
                <p>
                  You are also looking for any information you can find on how
                  other people market and bulid such apps with funding. You need a comprehensive
                  strategy based on how your competition gets to their users.
                </p>
                <p>We want to help !</p>
                <p>
                  All you have to do is click below, tell us what you need help
                  with. We will set up a call with you to discuss.
                </p>
                <p>Will you proceed to make your idea a reality?</p>
                <div className={styles.btnHolder}>
                  <button
                    className="btn-custom"
                    type="button"
                    onClick={() => setShowCallMe((prev) => !prev)}
                  >
                    Continue To Next Step
                  </button>
                </div>
              </p>
            </Banner>
          </div>
          <div className="col col-12 pb-2">
            <Banner
              heading="Common Mistakes"
              headingCenter
              secondary
              addMargin={false}
            >
              <p>
                <h3>Mistake 1: Ignoring the value of your idea.</h3>
                <br />
                <p>Your idea is very valuable.</p>
                <p>
                  You only have to build your app once for
                  {' '}
                  <b>ALL</b>
                  {' '}
                  the users
                  of your app !!
                  <br />
                </p>
                <p>
                  There is a simple formula to realize the value of your app.
                  Once you've built your app, all you need is a good number of
                  users. There are many ways to get to these users in large
                  quantities thanks to large platforms like Amazon, Google,
                  Facebook, Instagram, Reddit, Twitter, TikTok, Pinterest and
                  LinkedIn. You can also reach people at conferences.
                </p>
                <p>
                  Professional investors have taught us the signals of value
                  even before the app is built. If you know what to look for,
                  it's obvious why they make sense. We can show you what these
                  signals are and how you can measure them.
                </p>
                <p>
                  Even if you don't need an investment, you will see that
                  knowing what matters to professional investors could help you
                  do well because it will inform what you could value and work
                  towards.
                </p>
                <h5>
                  What is the market value of your idea and how to improve it?
                </h5>
                <p>
                  The value of an idea is a simple matter of the economics. We
                  will walk you through how investors think and evaluate your
                  idea.
                </p>
                <p>
                  Get the following:
                  <ol>
                    <li>
                      an
                      {' '}
                      <b>analysis</b>
                      {' '}
                      of the value of your idea
                    </li>
                    <li>
                      a
                      {' '}
                      <b>standard checklist</b>
                      {' '}
                      that investors (and you could)
                      use to value your idea
                    </li>
                    <li>
                      the
                      {' '}
                      <b>proven plan</b>
                      {' '}
                      to have a successful app
                    </li>
                  </ol>
                  ... on a
                  {' '}
                  <b>20 minute</b>
                  {' '}
                  call.
                </p>
                <p>
                  The
                  {' '}
                  <b>ONE</b>
                  {' '}
                  thing you can do
                  {' '}
                  <b>NOW</b>
                  {' '}
                  to make progress is
                  to ask for a quick call.
                </p>

                <div className={styles.btnHolder}>
                  <button
                    className="btn-custom"
                    type="button"
                    onClick={() => setShowCallMe((prev) => !prev)}
                  >
                    Help Value Your Idea
                  </button>
                </div>
                <div className={clsx('mb-2', styles.borderBottom)} />
                <h3>Mistake 2: Failing to motivate and build momentum.</h3>
                <p>
                  People are looking for leaders to follow. Someone who can show
                  momentum. Someone who is obviously doing cool new things.
                  Someone with evidence of progress. Even if the evidence is as
                  simple as a pretty design.
                </p>
                <p>
                  We want to help you be that leader. A design of your app idea
                  will help you show people what your idea is. The minute you
                  have that you look like you're more serious than someone who
                  is just talking about an idea.
                </p>
                <p>
                  Use our generous
                  {' '}
                  <b>$500</b>
                  {' '}
                  StartApp Prize to fund your
                  design of your app idea that you can share with people you
                  know to build momentum and excitement !!
                </p>
                <h5>How to win $500 towards your first design?</h5>
                <p>
                  Our generous
                  {' '}
                  <b>millionaire investors</b>
                  {' '}
                  believe that money
                  is meant to be given away.
                  <br />
                  When you
                  {' '}
                  <b>win $500</b>
                  {' '}
                  StartApp Prize from OpZoom you can
                  use it to fund your design phases.
                  <br />
                </p>
                <p>
                  You have
                  {' '}
                  <b>1-in-5 chance of winning</b>
                  {' '}
                  the StartApp prize if
                  you can get on a call.
                </p>
                <p>
                  Ask for a call below for a
                  {' '}
                  <b>20 minute</b>
                  {' '}
                  interview that
                  could win you
                  {' '}
                  <b>$500</b>
                  {' '}
                  !
                </p>
                <div className={styles.btnHolder}>
                  <button
                    className="btn-custom"
                    type="button"
                    onClick={() => setShowCallMe((prev) => !prev)}
                  >
                    Ask about the StartApp Prize
                  </button>
                </div>
                <div className={clsx('mb-2', styles.borderBottom)} />
                <h3>
                  Mistake 3: Ignoring lessons from other products and past
                  experience.
                </h3>
                <p>
                  Your app idea is precious and unique. It's also similar in
                  many ways to other ideas. It's a lot easier to succeed by
                  copying successful strategies than to do something completely
                  new.
                </p>
                <p>
                  You may have a lot of features in mind for your app. Many
                  features that you absolutely need.
                </p>
                <p>
                  There is one feature though that we see that people forget to
                  think about for a long time. This is a feature that helps you
                  find opportunities to imporve your app quickly. All investors
                  ask for this feature.
                </p>
                <p>Over 90% of our clients forget this valuable feature!</p>
                <h5>What is the best app building strategy?</h5>
                <p>
                  Your path to success can be easy if you have a cheat sheet of
                  what to build first and what can wait. This will help you
                  conserve your investment capital till you have evidence of
                  success. Get the cheat sheet that explains:
                  <ol>
                    <li>What features to build first?</li>
                    <li>
                      Which features do investors want that makes your app
                      valuable?
                    </li>
                    <li>How to find users for your app?</li>
                  </ol>
                </p>
                <p>
                  You can get the valuable
                  {' '}
                  <b>App Building Strategy</b>
                  {' '}
                  cheat-sheet when you get on a
                  {' '}
                  <b>20 minute</b>
                  {' '}
                  call.
                </p>
              </p>
              <div className={styles.btnHolder}>
                <button
                  className="btn-custom"
                  type="button"
                  onClick={() => setShowCallMe((prev) => !prev)}
                >
                  Get Help With Strategy
                </button>
              </div>
            </Banner>
          </div>
          {showCallMe && (
          <ModalNew isOpen={showCallMe} setIsOpen={setShowCallMe}>

            <FadeTransition
              tag="div"
              delay="0.1s"
              direction={FADE_DIRECTION.NONE}
              show
            >
              <ContactUs page={page} setShowCallMe={setShowCallMe} />
            </FadeTransition>
          </ModalNew>
          )}
        </div>
      </div>
    </div>
  );
};
export default Estimate;
